export const canUserDeletePost = (user, post) => {
    if (user.roles.includes('admin')) {
        return true;
    }
    if (post.author === user._id) {
        return true;
    }
    return false;
};
export const canUserDeletePostComment = (user, comment, post) => {
    if (user.roles.includes('admin')) {
        return true;
    }
    if (comment.author === user._id) {
        return true;
    }
    if (post.author === user._id) {
        return true;
    }
    return false;
};
export const canUserRatePostComment = (user, comment) => {
    if (comment.author !== user._id) {
        return true;
    }
    return false;
};
export function isAdminUser(user) {
    return user.roles.includes('admin');
}
